import React from 'react';
import './style.scss';

interface Props {
    id: string;
    label: string;
    active: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined
  }

const Switch:React.FC<Props> = (props) => {
  const {
    id, label, active, onClick,
  } = props;

  return (
    <div className="switch-container">
      <label htmlFor={id} className={label ? 'switch-label' : 'd-none'}>{label}</label>
      <button
        type="button"
        className={active ? 'second-container bg-primary' : 'second-container'}
        onClick={onClick}
        style={{ marginTop: '3.5px' }}
      >
        <div className={active ? 'switch-dot-left' : 'switch-dot-right'} />
      </button>
    </div>
  );
};

export default Switch;
